import {SORespInterphace} from '../../core/interphace/so-resp-interphace';
import {InterphaceCore} from './interphace.core';
import {ListEntry, CEProtocol, CEBase, createCEProtocol, RowSpec} from 'lionheartland';
import {
  DetailEntry, ScopeMatch,
  DetailFactory, DetailFactoryProtocol, EditableType
} from 'lionheartland';
import {BaseDetailType} from 'lionheartland';
import {EntityAttributesForDisplay} from 'lionheartland';
import {getHeading} from 'lionheartland';
import {ListSpecType} from 'lionheartland';
import {DisplayVectorStringFactory} from 'lionheartland';
import {ActiveUserService} from 'lionheartland';
import {EntityViewSpecProtocol} from 'lionheartland';
import { CommanderApp } from "../../land-app";
import {PutInterphaceFormFields} from './put-interphace-form-fields';
import {SOGetInterphace} from '../../core/interphace/so-get-interphace';
import {SOGetBlock} from '../../core/block/so-get-block';
import {SOGetEntity} from '../../core/entity/so-get-entity';
import {SOGetAttributeSpec} from '../../core/attribute-spec/so-get-attribute-spec';
import {SOGetProject} from '../../core/project/so-get-project';
import {SOGetOrganization} from '../../core/organization/so-get-organization';


export class CEInterphaceAttributesBase {

    name: DetailEntry
    description: DetailEntry
    interphaceType: DetailEntry
    blocks: DetailEntry
    entity: DetailEntry
    attributeSpecs: DetailEntry
    project: DetailEntry

    constructor(
        parentEntityViewSpec: EntityViewSpecProtocol,
        entity: SORespInterphace,
        app: CommanderApp,
        formFields: PutInterphaceFormFields
    ) {

        const displayStringFactory = new DisplayVectorStringFactory(app.displayOptions);
        let heading;


        this.name = new DetailEntry(
            'Name',
            entity.name,
            'name',
            BaseDetailType.text,
            null,
            EditableType.always,
            formFields.name
        )

        this.description = new DetailEntry(
            'Description',
            entity.description,
            'description',
            BaseDetailType.text,
            null,
            EditableType.always,
            formFields.description
        )

        this.interphaceType = new DetailEntry(
            'Interphace type',
            entity.interphaceType,
            'interphaceType',
            BaseDetailType.toggleGroup,
            null,
            EditableType.always,
            formFields.interphaceType
        )


        const blocksCore = app.makeCore( 'block');
        blocksCore.soGet = SOGetBlock.construct({
          interphace: new SOGetInterphace(entity.uid),
          organization: app.getScope('organization') ? new SOGetOrganization(app.getScope('organization').uid) : null,
        });
        blocksCore.soGet.queryOptions.sortKey = 'dateCreated';
        blocksCore.soGet.queryOptions.descending = true;
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            blocksCore
        )
        blocksCore.title = heading ? heading : blocksCore.title
        blocksCore.listTitle = 'Blocks'

        blocksCore.configureForDisplay(parentEntityViewSpec)

        this.blocks = new DetailEntry(
          heading ? heading : blocksCore.listTitle,
          null,
          'blocks',
          BaseDetailType.embeddedList,
          blocksCore,
          EditableType.never
        )

        const entityCore = app.makeCore( 'entity');
        entityCore.soGet = SOGetEntity.construct({
          organization: app.getScope('organization') ? new SOGetOrganization(app.getScope('organization').uid) : null,
        });
        entityCore.soGet.queryOptions.sortKey = 'dateCreated';
        entityCore.soGet.queryOptions.descending = true;
        let entityCeProtocol;
        if (entity.entity) {
            entityCeProtocol = createCEProtocol(
                entityCore.ceProtocol,
                parentEntityViewSpec,
                entityCore,
                entity.entity,
                app
            )
        }
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            entityCore
        )
        entityCore.title = heading ? heading : entityCore.title
        entityCore.listTitle = 'Entity'

        if (entity.entity) {
            displayStringFactory.reconfigure(
                entity.entity,
                parentEntityViewSpec ? parentEntityViewSpec.entityCore.type : null
            )
        }
        entityCore.configureForDisplay(parentEntityViewSpec)

        this.entity = new DetailEntry(
          heading ? heading : entityCore.listTitle,
          entityCeProtocol ? entityCeProtocol.entityListView.fullHeading : null,
          'entity',
          BaseDetailType.pushedDetail,
          entityCore,
          EditableType.always,
          formFields.entity
        )
        if (entity.entity) {
          this.entity.ceProtocol = entityCeProtocol;
          this.entity.cachedListEntry = entityCore.makeListEntry(parentEntityViewSpec, entity.entity, 0)
          entityCore.selectedEntity = entity.entity;
        }
        this.entity.singleFieldSelect = true

        const attributeSpecsCore = app.makeCore( 'attributeSpec');
        attributeSpecsCore.soGet = SOGetAttributeSpec.construct({
          interphace: new SOGetInterphace(entity.uid),
          organization: app.getScope('organization') ? new SOGetOrganization(app.getScope('organization').uid) : null,
        });
        attributeSpecsCore.soGet.queryOptions.sortKey = 'dateCreated';
        attributeSpecsCore.soGet.queryOptions.descending = true;
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            attributeSpecsCore
        )
        attributeSpecsCore.title = heading ? heading : attributeSpecsCore.title
        attributeSpecsCore.listTitle = 'Attribute specs'

        attributeSpecsCore.configureForDisplay(parentEntityViewSpec)

        this.attributeSpecs = new DetailEntry(
          heading ? heading : attributeSpecsCore.listTitle,
          null,
          'attributeSpecs',
          BaseDetailType.embeddedList,
          attributeSpecsCore,
          EditableType.never
        )

        const projectCore = app.makeCore( 'project');
        projectCore.soGet = SOGetProject.construct({
          organization: app.getScope('organization') ? new SOGetOrganization(app.getScope('organization').uid) : null,
        });
        projectCore.soGet.queryOptions.sortKey = 'dateCreated';
        projectCore.soGet.queryOptions.descending = true;
        let projectCeProtocol;
        if (entity.project) {
            projectCeProtocol = createCEProtocol(
                projectCore.ceProtocol,
                parentEntityViewSpec,
                projectCore,
                entity.project,
                app
            )
        }
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            projectCore
        )
        projectCore.title = heading ? heading : projectCore.title
        projectCore.listTitle = 'Project'

        if (entity.project) {
            displayStringFactory.reconfigure(
                entity.project,
                parentEntityViewSpec ? parentEntityViewSpec.entityCore.type : null
            )
        }
        projectCore.configureForDisplay(parentEntityViewSpec)

        this.project = new DetailEntry(
          heading ? heading : projectCore.listTitle,
          projectCeProtocol ? projectCeProtocol.entityListView.fullHeading : null,
          'project',
          BaseDetailType.pushedDetail,
          projectCore,
          EditableType.always,
          formFields.project
        )
        if (entity.project) {
          this.project.ceProtocol = projectCeProtocol;
          this.project.cachedListEntry = projectCore.makeListEntry(parentEntityViewSpec, entity.project, 0)
          projectCore.selectedEntity = entity.project;
        }
        this.project.singleFieldSelect = true
    }
}